import React, {useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HamburgetMenuClose, HamburgetMenuOpen } from "./Icons";
import { HashLink } from 'react-router-hash-link';
import SiteLogo from '../../images/logo-transparent.png'; // Adjust the path to your image file

const NavBar = () =>{
  const [click, setClick] = useState(false);
  const location = useLocation();
  const isHomeRoute = location.pathname === '/';


  const handleClick = () => setClick(!click);

   // Scroll to top whenever the route changes
   useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const [isScrolled, setIsScrolled] = useState(false);
  const navClassName = `${isHomeRoute ? 'home' : ''} ${isScrolled ? 'scrolled' : 'not-scrolled'}`.trim();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 200);
    };

    window.addEventListener('scroll', handleScroll);
    // Call it once on load in case user refreshes at scrolled position
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  return (
    <>
      <nav className={`navbar sticky-top ${navClassName}`}>
        <div className="nav-container container-full-width">
          <NavLink exact="true" to="/" className="nav-logo">
            {/* <i className="fas fa-code"></i> */}
            <div className="logo-text-wrapper">
              <span className="icon">
                <img className='me-2' width={60} alt="site-logo" src={SiteLogo} />
              </span>
              <span className="logo-text">Top Tech Giants</span>
            </div>
           

          </NavLink>

          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavLink
                exact="true"
                to="/"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Home
              </NavLink>
            </li>
            
            <li className="nav-item">
              <NavLink
                exact="true"
                to="/projects"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Projects
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact="true"
                to="/services"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Services
              </NavLink>
            </li>
            <li className="nav-item">
              <HashLink
                to="/#section-clients"
                className="nav-links"
                onClick={handleClick}
              >
                CLIENTS
              </HashLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact="true"
                to="/about"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                About
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                exact="true"
                to="/contact"
                activeclassname="active"
                className="nav-links"
                onClick={handleClick}
              >
                Contact
              </NavLink>
            </li>
          </ul>
          <div className="nav-icon" onClick={handleClick}>
            {/* <i className={click ? "fas fa-times" : "fas fa-bars"}></i> */}

            {click ? (
              <span className="icon">
               
                <HamburgetMenuClose />
              </span>
            ) : (
              <span className="icon">
                 <HamburgetMenuOpen />{" "}
              </span>
            )}
          </div>
        </div>
      </nav>
    </>
  );
}

export default NavBar;
